/*
 * ------------------------------------------------------------
 * Mesure INP reelle - fichier autonome padelit
 * Ne modifie aucun fichier natif du theme. Charge par une section
 * « Liquid personnalise » du pied de page : peut etre retire depuis
 * l'editeur de theme sans risque.
 *
 * Ce que fait le script :
 *  - observe les interactions (clic, tap, touche) des visiteurs ;
 *  - garde la plus lente de la page (= INP de la page vue) ;
 *  - identifie l'element touche et le script responsable (API LoAF) ;
 *  - envoie un evenement « inp » a Google Analytics 4 quand le visiteur
 *    quitte la page (uniquement sur le theme publie).
 *
 * Debug : ajouter ?inp_debug=1 a l'URL pour voir les mesures dans la
 * console, sans rien envoyer a GA4.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__pdltInpMonitor) return;
  window.__pdltInpMonitor = true;

  if (!('PerformanceObserver' in window)) return;
  var supported = PerformanceObserver.supportedEntryTypes || [];
  if (supported.indexOf('event') === -1) return;

  var GA4_ID = 'G-YX3WSRJG8E';
  var DEBUG = /[?&]inp_debug=1/.test(location.search);
  var theme = (window.Shopify && window.Shopify.theme) || {};
  var IS_LIVE = theme.role === 'main';

  var worst = null; // { entry, target }
  var interactions = 0;
  var seenIds = {};
  var loafs = [];
  var sent = false;

  function round(n) {
    return Math.round(n || 0);
  }

  function cut(str, max) {
    str = String(str || '');
    return str.length > max ? str.slice(0, max) : str;
  }

  // Selecteur court et lisible : section > element#id.classe
  function describe(el) {
    if (!el || !(el instanceof Element)) return '(element retire)';
    var parts = [];
    var node = el;
    for (var i = 0; node && node !== document.body && i < 3; i++) {
      var s = node.tagName.toLowerCase();
      if (node.id && !/^\d/.test(node.id)) {
        s += '#' + node.id.replace(/^shopify-section-(template|sections)--\d+__/, '');
        parts.unshift(s);
        break;
      }
      var cls = (typeof node.className === 'string' ? node.className : '')
        .trim()
        .split(/\s+/)
        .filter(function (c) {
          return c && c.length < 30;
        })
        .slice(0, 2);
      if (cls.length) s += '.' + cls.join('.');
      parts.unshift(s);
      node = node.parentElement;
    }
    var section = el.closest && el.closest('.shopify-section');
    var sectionName = section
      ? section.id.replace(/^shopify-section-(template|sections)--\d+__/, '').replace(/_[A-Za-z0-9]{6}$/, '')
      : '';
    return (sectionName ? '[' + sectionName + '] ' : '') + parts.join(' > ');
  }

  function scriptName(s) {
    var src = s.sourceURL || '';
    var file = src ? src.split('?')[0].split('/').pop() : 'inline';
    var host = '';
    try {
      if (src) host = new URL(src).host;
    } catch (e) {}
    if (/judgeme/.test(src)) file = 'judgeme:' + file;
    else if (/googletagmanager/.test(host)) file = 'gtag';
    else if (/seowill|seoant/.test(src)) file = 'seowill:' + file;
    else if (/shop-js|shop\.app/.test(src)) file = 'shop-js:' + file;
    var inv = (s.invoker || '').replace(/^https?:\/\/[^ ]+/, '').slice(0, 40);
    return file + (inv ? ' (' + inv + ')' : '');
  }

  // Script le plus couteux dans les frames qui recouvrent l'interaction
  function attributeScript(entry) {
    var start = entry.startTime;
    var end = entry.startTime + entry.duration;
    var best = null;
    for (var i = 0; i < loafs.length; i++) {
      var f = loafs[i];
      if (f.startTime + f.duration < start || f.startTime > end) continue;
      for (var j = 0; j < f.scripts.length; j++) {
        var s = f.scripts[j];
        if (!best || s.duration > best.duration) best = s;
      }
    }
    return best ? { name: scriptName(best), duration: round(best.duration) } : { name: '(aucun script long)', duration: 0 };
  }

  if (supported.indexOf('long-animation-frame') !== -1) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].duration >= 50) loafs.push(entries[i]);
        }
        if (loafs.length > 60) loafs = loafs.slice(-60);
      }).observe({ type: 'long-animation-frame', buffered: true });
    } catch (e) {}
  }

  try {
    new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.interactionId) continue;
        if (!seenIds[e.interactionId]) {
          seenIds[e.interactionId] = true;
          interactions++;
        }
        if (!worst || e.duration > worst.entry.duration) {
          // La cible est lue tout de suite : l'element peut disparaitre ensuite
          worst = { entry: e, target: describe(e.target) };
          if (DEBUG) log(worst);
        }
      }
    }).observe({ type: 'event', durationThreshold: 16, buffered: true });
  } catch (e) {
    return;
  }

  function payload() {
    var e = worst.entry;
    var script = attributeScript(e);
    var value = round(e.duration);
    return {
      value: value,
      metric_value: value,
      metric_rating: value <= 200 ? 'good' : value <= 500 ? 'needs-improvement' : 'poor',
      inp_event: e.name,
      inp_target: cut(worst.target, 100),
      inp_input_delay: round(e.processingStart - e.startTime),
      inp_processing: round(e.processingEnd - e.processingStart),
      inp_presentation: round(e.startTime + e.duration - e.processingEnd),
      inp_script: cut(script.name, 100),
      inp_script_ms: script.duration,
      inp_interactions: interactions,
      page_type: cut((window.Theme && window.Theme.template && window.Theme.template.name) || '', 40),
      non_interaction: true,
    };
  }

  function log(w) {
    var p = payload();
    console.log('[padelit INP] ' + p.value + ' ms (' + p.metric_rating + ')', p);
  }

  function send() {
    if (sent || !worst) return;
    sent = true;
    var params = payload();

    if (DEBUG || !IS_LIVE) {
      if (DEBUG) console.log('[padelit INP] envoi simule (non publie ou debug) :', params);
      return;
    }

    params.send_to = GA4_ID;
    params.transport_type = 'beacon';
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'inp', params);
    } else {
      // gtag attend un objet « arguments », pas un tableau
      window.dataLayer = window.dataLayer || [];
      (function () {
        window.dataLayer.push(arguments);
      })('event', 'inp', params);
    }
  }

  document.addEventListener(
    'visibilitychange',
    function () {
      if (document.visibilityState === 'hidden') send();
    },
    { capture: true }
  );
  window.addEventListener('pagehide', send, { capture: true });
})();
